<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hTxst9/image/FC-9781398419803.jpg?1685790893208" alt="This image is the cover for the book Good Food Good Health"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Good Food Good Health
      </h1>
      <p class="bookDescription body article font2">
        <p>Good Food Good Health is a collection of recipes for everyday healthy cooking. Some recipes are unique to the author’s family and are little known, but others are more common. Every recipe has been nutritionally analysed using a simple colour guide. Good Food Good Health is not just another cookbook. It provides a resource for choosing healthy diet options whilst introducing a new dimension of varieties and flavours, bringing excitement into everyday cooking and eating.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Fatima Patel
      </h2>
      
      <p class="authorDescription body article">People’s Book Prize Finalist, Summer 2014 This personal collection of recipes has been inspired by my drive to provide healthy, wholesome meals for my family. It is a collection of dishes from around the world which we enjoy at home. Some of the dishes were cooked by my mother and grandmother when I was a child. I have modified the recipes to reflect modern lifestyles and my quest for healthy food. I have tried to do this whilst maintaining the traditional tastes and flavours of a unique collection of family recipes, some of which are little known in the outside world. This update includes many other recipes which I have learned, and which my family and friends have enjoyed in our home. Some of these are well known international dishes, but I have hopefully provided healthy versions of these recipes without compromising on taste.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?122072bc